import React, { useMemo, useState } from "react";
import MUIButton from "../../../Component/UI/MUIButton/MUIButton";
import { Tooltip, Typography } from "@mui/material";
import { LLM_OPTIONS } from "../../../utils/constant";

const headers = ["Top Source", "Source Frequency"];

const SourceTableView = ({ data, llm }) => {
  const [visibleRows, setVisibleRows] = useState(10);
  data = data.sort((a, b) => b.urls.length - a.urls.length);

  console.log('data==>', data)
  const selectedLLM = LLM_OPTIONS.find(opt => opt.value === llm)?.name

  const handleShowMore = () => {
    setVisibleRows((prev) => prev + 15);
  };

  const maxDomainLength = useMemo(() => {
    return Math.max(...data?.map((row) => row?.src?.length), 10);
  }, [data]);

  const tableCellWidth = ["30%", "70%"];

  const maxTotalValue = useMemo(() => {
    return Math.max(...data.map((item) => item?.urls?.length), 1);
  }, [data]);

  const renderProgressBar = (item) => {
    const totalValue = item?.urls?.length;
    const barWidth = `${(totalValue / maxTotalValue) * 100}%`;

    return (
      <div
        style={{
          display: "flex",
          height: 10,
          borderRadius: 5,
          overflow: "hidden",
          width: barWidth,
          backgroundColor: "#36CFC2",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Tooltip
          title={
            <div style={{ textAlign: "left" }}>
              <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                {selectedLLM}
              </Typography>
              <div
                style={{
                  display: "inline-block",
                  width: 12,
                  height: 12,
                  backgroundColor: "#36CFC2",
                  marginRight: 5,
                  borderRadius: "50%",
                }}
              />
              <Typography style={{ display: "inline", fontSize: 14 }}>
                {item?.urls?.length}
              </Typography>
            </div>
          }
          arrow
          placement="top"
        >
          <div
            style={{
              width: `100%`,
              backgroundColor: "#36CFC2",
              height: "100%",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          maxHeight: "520px",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <table
          className="table table-striped"
          style={{ width: "100%", tableLayout: "fixed" }}
        >
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 2,
            }}
          >
            <tr className="prdtblHeader">
              {headers.map((header, index) => (
                <th
                  key={header}
                  style={{
                    width: tableCellWidth[index],
                    textAlign: "left",
                    padding: "10px",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!!data?.length ? (
              data?.slice(0, visibleRows)?.map((row, index) => {
                const rowHeight = Math.max(row?.urls?.length * 30, 40);

                return (
                  <tr key={index}>
                    {/* <td
                      style={{
                        minWidth: `${maxDomainLength}ch`,
                        verticalAlign: "middle",
                      }}
                    >
                      {row?.src}
                    </td> */}

                    <td
                      style={{
                        minWidth: `${maxDomainLength}ch`,
                        verticalAlign: "middle",
                      }}
                    >
                      <Tooltip
                        title={
                          <div style={{ textAlign: "left", maxWidth: 300 }}>
                            {row?.urls?.map((url, i) => (
                              <div
                                key={i}
                                style={{
                                  wordBreak: "break-all",
                                  marginBottom:
                                    i !== row?.urls.length - 1 ? "5px" : "",
                                  borderBottom:
                                    i !== row?.urls.length - 1
                                      ? "0.005px solid white"
                                      : "",
                                }}
                              >
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#fff",
                                    fontSize: "15px",
                                    // textDecoration: "underline",
                                  }}
                                >
                                  {url}
                                </a>
                              </div>
                            ))}
                          </div>
                        }
                        arrow
                        placement="top-start"
                      >
                        <span style={{ cursor: "pointer" }}>{row?.src}</span>
                      </Tooltip>
                    </td>

                    <td style={{ verticalAlign: "middle" }}>
                      {renderProgressBar(row)}
                    </td>
                    {/* <td
                      style={{
                        textAlign: "left",
                        height: rowHeight,
                        verticalAlign: "middle",
                      }}
                    >
                      {row?.urls?.map((url, i) => (
                        <div
                          key={i}
                          style={{
                            borderBottom:
                              i < row?.urls.length - 1 ? "1px solid #ddd" : "",
                            paddingBottom: "4px",
                          }}
                        >
                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {url}
                          </a>
                        </div>
                      ))}
                    </td> */}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {visibleRows < data.length && (
          <div style={{ textAlign: "center", padding: "10px" }}>
            <MUIButton variant="text" onClick={handleShowMore} id="load_more">
              Load More
            </MUIButton>
          </div>
        )}
      </div>
    </>
  );
};

export default SourceTableView;
